import { render } from "./HistoryPanel.vue?vue&type=template&id=7b9240a4&scoped=true"
import script from "./HistoryPanel.vue?vue&type=script&lang=js"
export * from "./HistoryPanel.vue?vue&type=script&lang=js"

import "./HistoryPanel.vue?vue&type=style&index=0&id=7b9240a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b9240a4"]])

export default __exports__